export const LOADING_PERFORMANCE_RECORD = "LOADING_PERFORMANCE_RECORD";
export const GET_PERFORMANCE_RECORD_LIST = "GET_PERFORMANCE_RECORD_LIST";
export const Add_PERFORMANCE_RECORD = "Add_PERFORMANCE_RECORD";
export const Update_PERFORMANCE_RECORD = "Update_PERFORMANCE_RECORD";
export const REMOVE_PERFORMANCE_RECORD = "REMOVE_PERFORMANCE_RECORD";